import { Button2 } from "@/ui2/atoms/Button";
import ChevronIcon from "@/assets/images/icons2/icon--chevron.svg?component";
import { cn } from "@/lib/helpers/cn";

type PageControlProps = {
  direction: "previous" | "next";
  isDisabled: boolean;
  onPress: () => void;
};

export function PageControl({ direction, isDisabled, onPress }: PageControlProps) {
  const isPrevious = direction === "previous";

  return (
    <Button2
      aria-label={isPrevious ? "Previous page" : "Next page"}
      className="tw:flex tw:size-8 tw:items-center tw:justify-center tw:rounded-lg"
      isDisabled={isDisabled}
      onPress={onPress}
      rawChildren
      variant="blank"
    >
      <ChevronIcon
        className={cn(
          "tw:size-5 tw:text-fill-secondary",
          isPrevious ? "tw:rotate-90" : "tw:-rotate-90",
        )}
      />
    </Button2>
  );
}
